import { render } from "./ScrollWidthSetting.vue?vue&type=template&id=7520a188"
import script from "./ScrollWidthSetting.vue?vue&type=script&lang=js"
export * from "./ScrollWidthSetting.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/h5/common/sys/miniProgram/setting/component/ScrollWidthSetting.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7520a188"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7520a188', __exports__)) {
    api.reload('7520a188', __exports__)
  }
  
  module.hot.accept("./ScrollWidthSetting.vue?vue&type=template&id=7520a188", () => {
    api.rerender('7520a188', render)
  })

}


export default __exports__